import { Component } from '@angular/core';
import { BlockModuleOverview } from '@src/app/@shared/models/step.model';
import { BlockAbstractComponent } from '@app/components/blocks/block.abstract.component';
import { PlIcon } from '@app/icon-library/icons';
import { IconFrame } from '@app/icon-library/lib/pl-icon.component';
import { EntityStatus } from '@shared/models/menu.model';

@Component({
  selector: 'pl-block-module-overview',
  templateUrl: './block-module-overview.component.html',
})
export class BlockModuleOverviewComponent extends BlockAbstractComponent<BlockModuleOverview, null> {
  protected readonly PlIcon: typeof PlIcon = PlIcon;
  protected readonly IconFrame: typeof IconFrame = IconFrame;
  protected readonly EntityStatus: typeof EntityStatus = EntityStatus;

  protected override initForm(): void {}

  protected override patchFormWithEmptyValue(): void {}

  protected override patchFormFromBlock(): void {}
}
